import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "注文番号",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfCyumonno12"
    label={label}
    size="small"
    inputProps={{ maxLength: 12 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;